// extracted by mini-css-extract-plugin
export default {"card":"Card_card__YUWxw","title":"Card_title__Ygtq3","genre":"Card_genre__Y8FzW"};